/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell\template\cellDate
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "../../base";
import { Watch } from "vue-property-decorator";

@Component
export default class CellDate extends Base {
  private get Value() {
    try {
      let value = eval("this.model." + this.prop.value);
      if (value) {
        let d = new Date(value);
        d.setHours(d.getHours() + 8);
        return d.toISOString().substr(0, 10);
      }
    } catch (error) {
      return null;
    }
  }
}
